export default "__VITE_ASSET__BkULynKD__"